import request from '@/utils/request'

// 提交 分解任务
export function submitFormData(form) {
  return request({
    url: 'version/decompose-task',
    method: 'post',
    data: { tasks: form }
  })
}

// 根据id获取需求信息
// 根据id查询需求
export function getEditDemand(demand_id, system_code) {
  return request({
    url: `demand/get-by-id-demand?demand_id=${demand_id}&system_code=${system_code}`,
    method: 'get'
  })
}

// 获取相关任务列表
export function getTask(demand_id) {
  return request({
    url: `demand/get-by-demand-related-tasks?demand_id=${demand_id}`,
    method: 'get'
  })
}
